import { render, staticRenderFns } from "./EventOutcomeTask.vue?vue&type=template&id=01d12a4a&scoped=true"
import script from "./EventOutcomeTask.vue?vue&type=script&lang=ts"
export * from "./EventOutcomeTask.vue?vue&type=script&lang=ts"
import style0 from "./EventOutcomeTask.vue?vue&type=style&index=0&id=01d12a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d12a4a",
  null
  
)

export default component.exports